// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Signup_wrapper__3FN4X"};